module.exports = __webpack_public_path__ + "static/img/g-premio.9522114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sistema-de-gestion-en/g-premio.jpg
// module id = twXY
// module chunks = 0